import {
  BufferGeometry,
  DoubleSide,
  Material,
  Mesh,
  MeshBasicMaterial,
  Vector3,
} from "three";
import * as Config from "../config/ViewerConfig";
import { MeasurementState } from "../measurement/types";

export class ExtendedMesh extends Mesh {
  private _points: Vector3[];
  private _defaultMaterial: Material;
  private _selectedMaterial: Material;
  private _hoveredMaterial: Material;

  get points() {
    return this._points;
  }
  constructor(material: Material = new MeshBasicMaterial({ color: 0x0000ff })) {
    const geometry = new BufferGeometry();
    super(geometry, material);

    this._defaultMaterial = material;
    this._selectedMaterial = new MeshBasicMaterial({
      color: Config.SELECTED_MEASUREMENT_COLOR,
      side: DoubleSide,
      opacity: 0.5,
      transparent: true,
    });
    this._hoveredMaterial = new MeshBasicMaterial({
      color: Config.HOVERED_MEASUREMENT_COLOR,
      side: DoubleSide,
      opacity: 0.5,
      transparent: true,
    });
  }
  public prepareRendering(points: Vector3[], meshIndices: number[]) {
    this.geometry.setFromPoints(points);
    this.geometry.setIndex(meshIndices);
    this.geometry.getAttribute("position").needsUpdate = true;
    this.geometry.index.needsUpdate = true;
  }

  public setMaterialByState(state: MeasurementState) {
    this.material = {
      default: this._defaultMaterial,
      selected: this._selectedMaterial,
      hovered: this._hoveredMaterial,
    }[state];
  }
}
